
/* ==========================================
   BOWKS | MOBILE DRAWER ACCORDION
   Dawn Compatible
   v1.0
========================================== */

(() => {
  "use strict";

  function initBowksAccordion() {

    const navs = document.querySelectorAll(
      "header-drawer .bowks-nav"
    );

    navs.forEach((nav) => {

      if (nav.dataset.accordionReady === "true") {
        return;
      }

      nav.dataset.accordionReady = "true";

      const drawer = nav.closest(
        "details.menu-drawer-container"
      );

      /* --------------------------------------
         01 / GET PANEL
      -------------------------------------- */

      function getPanel(toggle) {

        const id = toggle.getAttribute(
          "aria-controls"
        );

        if (!id) return null;

        return nav.querySelector(
          `#${CSS.escape(id)}`
        );
      }

      /* --------------------------------------
         02 / CLOSE ACCORDION
      -------------------------------------- */

      function closeToggle(toggle) {

        const panel = getPanel(toggle);

        if (!panel) return;

        toggle.setAttribute(
          "aria-expanded",
          "false"
        );

        panel.classList.remove("is-open");
        panel.inert = true;

        // 子階層の状態もリセット
        panel
          .querySelectorAll(".bowks-nav__toggle")
          .forEach((childToggle) => {
            childToggle.setAttribute(
              "aria-expanded",
              "false"
            );
          });

        panel
          .querySelectorAll(".bowks-nav__panel")
          .forEach((childPanel) => {
            childPanel.classList.remove("is-open");
            childPanel.inert = true;
          });
      }

      /* --------------------------------------
         03 / OPEN ACCORDION
      -------------------------------------- */

      function openToggle(toggle) {

        const panel = getPanel(toggle);

        if (!panel) return;

        // 同じ階層の開いている項目を閉じる
        const parentList = toggle.closest(
          ".bowks-nav__list"
        );

        if (parentList) {

          Array.from(parentList.children).forEach(
            (item) => {

              const sibling = Array.from(
                item.children
              ).find((element) => {
                return element.classList?.contains(
                  "bowks-nav__toggle"
                );
              });

              if (
                sibling &&
                sibling !== toggle
              ) {
                closeToggle(sibling);
              }

            }
          );

        }

        toggle.setAttribute(
          "aria-expanded",
          "true"
        );

        panel.inert = false;
        panel.classList.add("is-open");
      }

      /* --------------------------------------
         04 / TOGGLE
      -------------------------------------- */

      function toggleAccordion(toggle) {

        const isOpen =
          toggle.getAttribute(
            "aria-expanded"
          ) === "true";

        if (isOpen) {
          closeToggle(toggle);
        } else {
          openToggle(toggle);
        }
      }

      /* --------------------------------------
         05 / CLICK HANDLING
      -------------------------------------- */

      nav.addEventListener(
        "click",
        (event) => {

          const toggle = event.target.closest(
            ".bowks-nav__toggle"
          );

          if (
            !toggle ||
            !nav.contains(toggle)
          ) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          toggleAccordion(toggle);

        },
        true
      );

      /* --------------------------------------
         06 / DRAWER RESET
      -------------------------------------- */

      if (drawer) {

        const observer = new MutationObserver(
          () => {

            if (!drawer.open) {

              nav
                .querySelectorAll(
                  ".bowks-nav__toggle"
                )
                .forEach(closeToggle);

            }

          }
        );

        observer.observe(drawer, {
          attributes: true,
          attributeFilter: ["open"]
        });
      }
    });
  }

  /* ----------------------------------------
     07 / INITIALIZE
  ---------------------------------------- */

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      initBowksAccordion
    );

  } else {

    initBowksAccordion();

  }

  document.addEventListener(
    "shopify:section:load",
    initBowksAccordion
  );

})();
